import { createContext, use } from "react";
import type { ExportValueSettings } from "../../../common/export/exportTypes.ts";

export interface ExportContextValue {
  container: HTMLElement | null;
  setContainer: (container: HTMLElement | null) => void;
  valueSettings?: ExportValueSettings;
  disabled?: boolean;
}

export const ExportStateContext = createContext<ExportContextValue | undefined>(undefined);

export const useExportStateContext = (): ExportContextValue => {
  const context = use(ExportStateContext);
  if (!context) {
    throw new Error("Export controls require an ExportStateContextProvider");
  }
  return context;
};
